/**
 * The T-shirt sizes (S, M, L, XL) of the products that are sized by the platform's own size configs (Ross, Apprise, WorkWise, AppCentral).
 * The product lines (Traverse, Process Pro) do NOT use them: they are sized by the RDS pool tiers (data/sizeCatalog.ts).
 */
import type { TShirtSize } from '@/types'

/** The sizes in display order. */
export const T_SHIRT_SIZES: readonly TShirtSize[] = Object.freeze(['S', 'M', 'L', 'XL'] as const)

export const T_SHIRT_SIZE_LABELS: Readonly<Record<TShirtSize, string>> = Object.freeze({ S: 'Small', M: 'Medium', L: 'Large', XL: 'Extra Large' })
